<template>
  <div
    :class="[
      'input-file-drop-box',
      {
        'input-file-drop-box--active': active && !disabled,
        'input-file-drop-box--disabled': active && disabled
      }
    ]"
    :data-active="active"
    @dragenter.prevent="setActive"
    @dragover.prevent="setActive"
    @dragleave.prevent="setInactive"
    @drop.prevent="onDrop"
  >
    <slot name="content"></slot>
    <div
      v-if="active"
      class="input-file-drop-box--overlay"
      :style="{ backgroundColor: overlayBackgroundColor }"
    >
      <slot v-if="!disabled" name="active">
        <span>{{ t('general__data__file-drop') }}</span>
      </slot>
      <slot v-else name="disabled" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, onUnmounted, ref, toRefs } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps({
  disabled: { type: Boolean, default: false },
  overlayBackgroundColor: {
    type: String,
    default: 'rgba(255, 255, 255, 0.8)'
  }
})
const { disabled } = toRefs(props)
interface EMITS {
  (e: 'files-dropped', val: File[])
  (e: 'items-dropped', val: DataTransferItem[])
}
const emits = defineEmits<EMITS>()
const { t } = useI18n()
const events = ['dragenter', 'dragover', 'dragleave', 'drop']
const active = ref(false)
let inActiveTimeout: any = null

function onDrop(event: DragEvent) {
  if (disabled.value) return
  const files = (event as DragEvent).dataTransfer?.files
  if (!files?.length) return
  setInactive()
  if (event.dataTransfer?.items) {
    emits('items-dropped', event.dataTransfer?.items ? [...event.dataTransfer.items] : [])
  } else if (event.dataTransfer?.files) {
    emits('files-dropped', event.dataTransfer?.files ? [...event.dataTransfer.files] : [])
  }
}

function preventDefaults(event) {
  event.preventDefault()
}
function setActive(event: DragEvent) {
  const dt = event.dataTransfer
  if (
    dt &&
    dt.types &&
    (dt.types.indexOf ? dt.types.indexOf('Files') != -1 : dt.types.includes('Files'))
  ) {
    active.value = true
    clearTimeout(inActiveTimeout)
  }
}
function setInactive() {
  inActiveTimeout = setTimeout(() => {
    active.value = false
  }, 50)
}

onMounted(() => {
  events.forEach((eventName) => {
    document.body.addEventListener(eventName, preventDefaults)
  })
})

onUnmounted(() => {
  events.forEach((eventName) => {
    document.body.removeEventListener(eventName, preventDefaults)
  })
})
</script>

<style lang="scss" scoped>
.input-file-drop-box {
  position: relative;
  width: 100%;
  height: 100%;

  &--disabled {
    cursor: not-allowed;
  }

  &--overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
  }
}
</style>
